export const sizes = {
  progress: {
    mobile: 25,
    desktop: 60
  }
}